import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as yup from 'yup';

import {
  Input,
  InputState,
  InputType,
  BaseFormInputProps,
} from '../Input/Input';

export enum FormInputMessageLabelName {
  messageLabel = 'messageLabel',
  messageRequiredLabel = 'messageRequiredLabel',
}

const messages = defineMessages({
  messageLabel: {
    id: 'src.components.FormInputMessage.messageLabel',
    defaultMessage: 'Message',
  },
  messageRequiredLabel: {
    id: 'src.components.FormInputMessage.messageRequiredLabel',
    defaultMessage: 'Message *',
  },
  messageEmptyError: {
    id: 'src.components.FormInputMessage.messageEmptyError',
    defaultMessage: 'Message is a required field',
  },
});

export const messageValidationSchema = yup.string().trim();

export const messageRequiredValidationSchema = yup.string().required('messageEmptyError').trim();

export type FormInputMessageErrors = 'messageEmptyError';

export type FormFieldsMessage = {
  message: string;
};

export const formFieldsMessageDefaultValue: FormFieldsMessage = {
  message: '',
};

export type Props = UseFormRegisterReturn & BaseFormInputProps & {
  error?: FieldError;
  isDisabled?: boolean;
  isNoLabel?: boolean;
  labelName?: FormInputMessageLabelName;
};

export const FormInputMessage = React.memo(React.forwardRef((
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement | HTMLTextAreaElement>,
) => {
  const {
    error,
    labelName = FormInputMessageLabelName.messageRequiredLabel,
    isDisabled = false,
    isNoLabel,
    ...rest
  } = props;

  return (
    <Input
      inputType={InputType.TextArea}
      state={
        isDisabled && InputState.Disabled
        || error && InputState.Error
        || undefined
      }
      label={!isNoLabel ? <FormattedMessage {...messages[labelName]} /> : undefined}
      errorMessage={
        error
        && <FormattedMessage {...messages[error?.message as FormInputMessageErrors]} />
      }
      type='text'
      {...rest}
      ref={ref}
    />
  );
}));

FormInputMessage.displayName = 'FormInputMessage';
